import React from "react";

// You can pass an optional 'message' prop to change the loading text dynamically
const Loader = ({ message = "Synchronizing" }) => {
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#0B1A30]/90 backdrop-blur-md select-none w-screen h-screen">
      
      {/* Spinner Graphic */}
      <div className="relative flex items-center justify-center w-32 h-32">
        {/* Outer Glow / Pulse Layer */}
        <div className="absolute inset-0 rounded-full bg-gradient-to-tr from-[#1A3D6D] to-[#C9FAC8] opacity-30 blur-2xl animate-pulse duration-2000" />

        {/* Layer 1: Outer Fast Track (Clockwise) */}
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-[#C9FAC8] border-r-[#1A3D6D] animate-spin" 
             style={{ animationDuration: '1.2s' }} />

        {/* Layer 2: Middle Track (Counter-Clockwise) */}
        <div className="absolute inset-2 rounded-full border-2 border-transparent border-b-[#FF9800] border-l-[#1A3D6D] animate-spin [animation-direction:reverse]"
             style={{ animationDuration: '1.8s' }} />

        {/* Layer 3: Inner Core Ring (Clockwise & Slow) */}
        <div className="absolute inset-5 rounded-full border-2 border-transparent border-t-[#C9FAC8] border-b-[#FF9800] opacity-80 animate-spin"
             style={{ animationDuration: '2.5s' }} />

        {/* Layer 4: Center Quantum Dot */}
        <div className="absolute w-4 h-4 rounded-full bg-white shadow-[0_0_15px_#C9FAC8] animate-ping opacity-75" />
        <div className="absolute w-3 h-3 rounded-full bg-gradient-to-br from-white to-[#C9FAC8] shadow-[0_0_10px_rgba(255,255,255,0.8)]" />
      </div>

      {/* Dynamic Typography */}
      <div className="mt-8 text-center space-y-1.5">
        <h3 className="text-sm font-bold tracking-[0.3em] uppercase bg-gradient-to-r from-white via-[#C9FAC8] to-white bg-clip-text text-transparent animate-pulse">
          {message}
        </h3>
        <p className="text-[11px] font-medium tracking-widest text-slate-400 opacity-80">
          Waiting For Your Internet...
        </p>
      </div>
    </div>
  );
};

export default Loader;